import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;




const currentStep = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const completedSteps = (value: number) => {
  return currentStep.value + 1 > value;
};

return (_ctx: any,_cache: any) => {
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!

  return (_openBlock(), _createBlock(_component_v_stepper, {
    "alt-labels": "",
    "model-value": currentStep.value,
    style: {"background-color":"#f0f0f0","box-shadow":"none","overflow":"hidden"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_stepper_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_stepper_item, {
            title: "Patient Information",
            style: {"opacity":"initial"},
            value: "1",
            color: completedSteps(1) ? '#FD408F' : '',
            class: _normalizeClass(
          !completedSteps(1) ? 'fsa-stepper-item' : 'fsa-stepper-item-completed'
        ),
            "selected-class": "fsa-stepper-item-selected"
          }, null, 8, ["color", "class"]),
          _createVNode(_component_v_divider, {
            color: completedSteps(1) ? '#FD408F' : '#B08EB2',
            style: {"opacity":"initial"}
          }, null, 8, ["color"]),
          _createVNode(_component_v_stepper_item, {
            title: "Insurance Information",
            value: "2",
            style: {"opacity":"initial","color":"#b08eb2"},
            color: completedSteps(2) ? '#FD408F' : '',
            class: _normalizeClass(
          !completedSteps(2) ? 'fsa-stepper-item' : 'fsa-stepper-item-completed'
        ),
            "selected-class": "fsa-stepper-item-selected"
          }, null, 8, ["color", "class"]),
          _createVNode(_component_v_divider, {
            color: completedSteps(2) ? '#FD408F' : '#B08EB2',
            style: {"opacity":"initial"}
          }, null, 8, ["color"]),
          _createVNode(_component_v_stepper_item, {
            title: "Claim Information",
            value: "3",
            style: {"opacity":"initial","color":"#b08eb2"},
            class: _normalizeClass(
          !completedSteps(3) ? 'fsa-stepper-item' : 'fsa-stepper-item-completed'
        ),
            color: completedSteps(3) ? '#FD408F' : ''
          }, null, 8, ["class", "color"]),
          _createVNode(_component_v_divider, {
            color: completedSteps(3) ? '#FD408F' : '#B08EB2',
            style: {"opacity":"initial"}
          }, null, 8, ["color"]),
          _createVNode(_component_v_stepper_item, {
            title: "Review",
            value: "4",
            style: {"opacity":"initial","color":"#b08eb2"},
            color: completedSteps(4) ? '#FD408F' : '#B08EB2',
            class: _normalizeClass(
          !completedSteps(4) ? 'fsa-stepper-item' : 'fsa-stepper-item-completed'
        ),
            "selected-class": "fsa-stepper-item-selected"
          }, null, 8, ["color", "class"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})